import { render, staticRenderFns } from "./ParcelsTableMobile.vue?vue&type=template&id=13a541ea&scoped=true"
import script from "./ParcelsTableMobile.vue?vue&type=script&lang=js"
export * from "./ParcelsTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a541ea",
  null
  
)

export default component.exports